<div class="container my-5">
  <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
    <h4 class="fw-bold text-black fs-3 mb-3 mb-md-0 mt-4">Privacy Policy</h4>
    <p class="fw-bold text-end text-black fs-3 mb-0">Effective Date: <span class="text-black">18th June, 2025</span></p>
  </div>

  <p class="mt-4 text-black" style="font-size: 16px;">
    This Privacy Notice applies to <strong>Getikk,</strong> a product offered by <strong>Cixcent Technologies Private
      Limited </strong>("Company", "we", "us", or "our"). 
  <p class=" text-black">It describes how and why we may collect, store, use, and/or share ("process") your personal
    information when you use our services ("Services"), such as when you: </p>

  <ul>
    <li>
      Visit our website at
      <a routerLink="/home" class="text-primary text-decoration-none" target="_blank">https://getikk.com/</a>,
      or any other associated web pages operated by Cixcent Technologies Private Limited
    </li>
    <li>
      Use Getikk features including WhatsApp automation, campaign tools, form integrations, and related services
    </li>
    <li>
      Interact with our team through support, marketing, or sales channels connected to <strong>Getikk</strong><br />
    <li>
      Please note that while Getikk operates as an independent brand, all legal responsibilities, including data privacy
      and protection, are fulfilled by <strong>Cixcent Technologies Private Limited</strong>.
    </li>
    <li>Engage with us in other related ways, including any sales, marketing, or events</li>
  </ul>

  <p class="mt-3 text-black">
    <strong>Questions or concerns?</strong> Reading this privacy notice will help you understand your privacy rights and
    choices. If you do not agree with our policies and practices, please do not use our Services.
    If you still have any questions or concerns, please contact us at
    <span class="text-primary">info@cixcent.com</span>.
  </p>
  <div class="container my-5" style="font-size: 14px;">
    <div class="mb-4">
      <h6 class="fw-semibold fs-3 text-black ">Privacy Policy Summary for Getikk</h6>
      <p class="text-black ">This summary highlights key points from our Privacy Notice. For more detailed information,
        you can explore each section by using the links provided below or refer to the full Table of Contents to
        navigate to the specific topic you are interested in. </p>
      <a (click)="setFocus('section1')" class="text-primary small text-decoration-none cursor-pointer">Click here to learn more.</a>
    </div>
    <div   class="mb-4">
      <h6 class="fw-semibold fs-4 text-black">What personal information do we process?</h6>
      <p class="text-black">
        When you visit, use, or interact with our Services through Getikk
        <a routerLink="/home"
          class="text-primary text-decoration-none">https://getikk.com/</a>,
        we may process personal information depending on your interactions, the features you use, and your choices.
      </p>
      <a (click)="setFocus('section2')" class="text-primary small text-decoration-none cursor-pointer">Click here to learn more.</a>
    </div>
    <div class="mb-4">
      <h6 class="fw-semibold fs-4 text-black">Do we process any sensitive personal information?</h6>
      <p class="text-black">No, we do not process sensitive personal information.</p>
      <a (click)="setFocus('section3')" class="text-primary small text-decoration-none  cursor-pointer">Click here to learn more.</a>
    </div>
    <div class="mb-4">
      <h6 class="fw-semibold fs-4 text-black">Do we receive any information from third parties?</h6>
      <p class="text-black">Yes, we may receive information from third-party sources such as public databases,
        advertising or marketing partners, social media platforms, and other service providers. </p>
      <a (click)="setFocus('section4')" class="text-primary small text-decoration-none 6 cursor-pointer">Click here to learn more.</a>
    </div>

    <div class="mb-4">
      <h6 class="fw-semibold fs-4 text-black">How do we process your information?</h6>
      <p class="text-black">
        We process your data to deliver, operate, and enhance Getikk's services—like WhatsApp automation, campaign
        tracking, and customer interactions. We may also use your information to improve user experience,
        for security, and as required by law. All processing is done based on a valid legal basis. 
      </p>
      <a (click)="setFocus('section5')" class="text-primary small text-decoration-none 6 cursor-pointer">Click here to learn more.</a>
    </div>

    <div class="mb-4">
      <h6 class="fw-semibold fs-4 text-black">When and with whom do we share personal information?</h6>
      <p class="text-black">
        We may share your data in specific cases—such as with third-party service providers, partners, or when legally
        obligated to do so. 
      </p>
      <a (click)="setFocus('section6')" class="text-primary small text-decoration-none 6 cursor-pointer">Click here to learn more.</a>
    </div>

    <div class="mb-4">
      <h6 class="fw-semibold fs-4 text-black">How do we keep your information safe?</h6>
      <p class="text-black">
        We implement both organizational and technical safeguards to protect your information. However, no digital
        platform is 100% secure, and we cannot guarantee complete protection from unauthorized access.
      </p>
      <a (click)="setFocus('section7')" class="text-primary small text-decoration-none 6 cursor-pointer">Click here to learn more.</a>
    </div>

    <!-- <div class="mb-4">
    <h6 class="fw-semibold fs-4 text-black">How do we keep your information safe?</h6>
    <p class="text-black">
      We implement both organizational and technical safeguards to protect your information. However, no digital
      platform is 100% secure,
      and we cannot guarantee full protection against all risks.
    </p>
    <a href="#" class="text-primary small text-decoration-none">Click here to learn more.</a>
  </div> -->

    <div class="mb-4">
      <h6 class="fw-semibold fs-4 text-black">What are your rights?</h6>
      <p class="text-black">
        Depending on your location, applicable privacy laws may grant you specific rights regarding your personal data,
        such as access, correction, or deletion. 
      </p>
      <a (click)="setFocus('section8')" class="text-primary small text-decoration-none cursor-pointer">Click here to learn more.</a>
    </div>

    <div class="mb-4">
      <h6 class="fw-semibold fs-4 text-black">How can you exercise your rights?</h6>
      <p class="text-black">
        You can exercise your rights by contacting us directly or submitting a request through our data subject access
        request form. We’ll respond in line with relevant data protection regulations. 
      </p>
      <a (click)="setFocus('section9')" class="text-primary small text-decoration-none cursor-pointer">Click here to learn more.</a>
    </div>

    <div class="mb-4">
      <h6 class="fw-semibold fs-4 text-black">Want to know more about how Getikk handles your information?</h6>
      <a (click)="setFocus('section10')" class="text-primary small text-decoration-none cursor-pointer">Click here to read the full Privacy Notice.</a>
    </div>
  </div>

  <div class="container my-5" >
    <h5 class="fw-bold fs-4 pb-2 text-black">TABLE OF CONTENTS</h5>

    <ol class="ps-3 list-unstyled" >
      <li id="section1"><a class="text-primary text-decoration-none d-block mb-1 cursor-pointer" (click)="setFocus('info1')">1.WHAT INFORMATION DO WE
          COLLECT?</a></li>
      <li id="section2"><a class="text-primary text-decoration-none d-block mb-1 cursor-pointer" (click)="setFocus('info2')">2.HOW DO WE PROCESS YOUR
          INFORMATION?</a></li>
      <li id="section3"><a class="text-primary text-decoration-none d-block mb-1 cursor-pointer" (click)="setFocus('info3') ">3.WHAT LEGAL BASES DO WE RELY ON
          TO
          PROCESS YOUR PERSONAL INFORMATION?</a></li>
      <li id="section4"><a class="text-primary text-decoration-none d-block mb-1 cursor-pointer" (click)="setFocus('info4')">4.WHEN AND WITH WHOM DO WE SHARE
          YOUR PERSONAL INFORMATION?</a></li>
      <li id="section5"><a class="text-primary text-decoration-none d-block mb-1 cursor-pointer " (click)="setFocus('info5') ">5.DO WE USE COOKIES AND OTHER
          TRACKING TECHNOLOGIES?</a></li>
      <li id="section6"><a class="text-primary text-decoration-none d-block mb-1 cursor-pointer" (click)="setFocus('info6')">6.HOW DO WE HANDLE YOUR SOCIAL
          LOGINS?</a></li>
      <li id="section7"><a  class="text-primary text-decoration-none d-block mb-1 cursor-pointer" (click)="setFocus('info7')">7.HOW LONG DO WE KEEP YOUR
          INFORMATION?</a></li>
      <li id="section8"><a class="text-primary text-decoration-none d-block mb-1 cursor-pointer" (click)="setFocus('info8')">8.HOW DO WE KEEP YOUR INFORMATION
          SAFE?</a></li>
      <li id="section9"><a  class="text-primary text-decoration-none d-block mb-1 cursor-pointer" (click)="setFocus('info9') ">9.DO WE COLLECT INFORMATION FROM
          MINORS?</a></li>
      <li id="section10"><a class="text-primary text-decoration-none d-block mb-1 cursor-pointer" (click)="setFocus('info10')">10.WHAT ARE YOUR PRIVACY
          RIGHTS?</a></li>
      <li id="section11"><a  class="text-primary text-decoration-none d-block mb-1 cursor-pointer" (click)="setFocus('info11')">11.CONTROLS FOR DO-NOT-TRACK
          FEATURES</a></li>
      <li id="section12"><a class="text-primary text-decoration-none d-block mb-1 cursor-pointer " (click)="setFocus('info12')">12.DO WE MAKE UPDATES TO THIS
          NOTICE?</a></li>
      <li id="section13"><a  class="text-primary text-decoration-none d-block mb-1 cursor-pointer" (click)="setFocus('info13')">13.HOW CAN YOU CONTACT US ABOUT
          THIS NOTICE?</a></li>
      <li id="section14"><a class="text-primary text-decoration-none d-block mb-1 cursor-pointer" (click)="setFocus('info14')">14.HOW CAN YOU REVIEW, UPDATE, OR
          DELETE THE DATA WE COLLECT FROM YOU?</a></li>
    </ol>
  </div>
  <div class="container my-5" style="font-size: 14px;">
    <div id="info1" class="mb-4">
      <h3 class="fw-semibold fs-3 text-black cursor-pointer">1. WHAT INFORMATION WE COLLECT? </h3>
      <h4 class="fw-semibold fs-6 text-black ">Personal information you disclose to us </h4>
      <p class="text-black "><strong>In Short:</strong> We collect personal information that you provide to us. <br>
        We collect personal information that you voluntarily  provide us when you register on the services, express an
        interest in obtaining information about us or our products or services, when you participate in activities on
        the
        services,
        or otherwise when you contact us.</p>
    </div>
    <div class="mb-4">
      <h6 class="fw-semibold fs-6 text-black ">Personal Information Provided by You. </h6>
      <p class="text-black">
        The personal information that we collect depends on the context of your interactions with us and the services,
        the
        choices you make,
        and the products and features you use. The personal information we collect may include the following: 
      </p>
      <ul>
        <li>
          Names
        </li>
        <li>
          Phone Numbers
        </li>
        <li>
          Email Address
        </li>
        <li>
          Job Titles
        </li>
        <li>
          UseNames
        </li>
        <li>
          Passwords
        </li>
        <li>
          Mailing Addresses
        </li>
        <li>
          Billing Addresses
        </li>
        <li>
          Debit/Credit Card Numbers
        </li>
      </ul>
    </div>
    <div  class="mb-4">
      <h6 class="fw-semibold fs-4 text-black">Sensitive Information</h6>
      <p class="text-black">We do not process sensitive information.</p>
    </div>

    <div    class="mb-4">
      <h6 class="fw-semibold fs-4 text-black">Payment Data</h6>
      <p class="text-black">
        We may collect data necessary to process your payment if you make  pruchases, such as your payment instrument
        number, and the security code associated with your payment instrument.<br>
        <strong>Social Media Login Data</strong>. We may provide you with the option to register with us using your
        existing social media account details, like your Facebook, Twitter, or other social media account. If you choose
        to register in this way,
        we will collect the information described in the section called  <span class="text-primary">"HOW DO WE HANDLE
          YOUR
          SOCIAL LOGINS?"</span> 
      <p class="text-black">below. 
        for security, and as required by law. All processing is done based on a valid legal basis. 
      </p>
      <span>All personal information that you provide to us must be true, complete, and accurate, and you must notify us
        of any changes to such personal information. </span>
    </div>

    <div  class="mb-4">
      <h4 class="fw-semibold fs-4 text-black ">Information automatically collected</h4>
      <p class="text-black "><strong>In Short: </strong>Some information — such as your Internet Protocol (IP) address
        and/or browser and device characteristics —
        is collected automatically when you visit our Services. </p>
      <p class="text-black ">We automatically collect certain information when you visit, use, or navigate the Services.
        This information does not reveal your specific identity (like your name or contact information) but may include
        device and usage information, such as your IP address, browser and device characteristics, operating system,
        language preferences, referring URLs, device name, country, location, information about how and when you use our
        Services, and other technical information.
        This information is primarily needed to maintain the security and operation of our Services, and for our
        internal analytics and reporting purposes. </p>
      <p class="text-black ">Like many businesses, we also collect information through cookies and similar
        technologies. 
      </p>
    </div>

    <div  class="mb-4">
      <h6 class="fw-semibold fs-4 text-black">The information we collect includes:</h6>
      <ul>
        <li>
          Log and Usage Data. Log and usage data is service-related, diagnostic, usage, and performance information our
          servers automatically collect when you access or use our Services and which we record in log files. Depending
          on
          how you interact with us, this log data may include your IP address, device information, browser type, and
          settings and information about your activity in the Services (such as the date/time stamps associated with
          your
          usage, pages and files viewed, searches, and other actions you take such as which features you use),
          device event information (such as system activity, error reports (sometimes called "crash dumps"), and
          hardware
          settings). 
        </li>
        <li>
          Device Data. We collect device data such as information about your computer, phone, tablet, or other device
          you
          use to access the Services. Depending on the device used, this device data may include information such as
          your
          IP address (or proxy server), device and application identification numbers, location, browser type, hardware
          model,
          Internet service provider and/or mobile carrier, operating system, and system configuration information. 
        </li>
      </ul>

      <p class="text-black"> Information collected from other sources </p>
      <p class="text-black"><strong>In Short:</strong> We may collect limited data from public databases, marketing
        partners, social media platforms, and other outside sources. </p>
      <p class="text-black">In order to enhance our ability to provide relevant marketing, offers, and services to you
        and
        update our records, we may obtain information about you from other sources, such as public databases, joint
        marketing partners, affiliate programs, data providers, social media platforms, and from other third parties.
        This
        information includes mailing addresses, job titles, email addresses, phone numbers, intent data (or
        user behaviour data), Internet Protocol (IP) addresses, social media profiles, social media URLs, and custom
        profiles, for purposes of targeted advertising and event promotion. If you interact with us on a social media
        platform using your social media account (e.g., Facebook or Twitter), we receive personal information about you
        such as your name, email address, and gender.
        Any personal information that we collect from your social media account depends on your social media account's
        privacy settings. </p>
    </div>

    <div  id="info2" class="mb-4">
      <h3 class="fw-semibold fs-4 text-black mb-3 cursor-pointer">2. HOW DO WE PROCESS YOUR INFORMATION? </h3>

      <p class="text-black mb-3">
        <strong>In Short:</strong> We process your information to provide, improve, and administer
        our Services, communicate with you, for security and fraud prevention,
        and to comply with law. We may also process your information for other purposes with your consent. 
      </p>

      <strong class="d-block mb-3">
        We process your personal information for a variety of reasons, depending on how you interact with our
        Services, including: 
      </strong>

      <ul class="ps-3">
        <li class="mb-3">
          <strong>To facilitate account creation and authentication and otherwise manage user accounts. </strong>
          <span class="text-black d-block mt-1">We may process your information so you can create and log in to your
            account, as well as
            keep your account in working order. </span>
        </li>
        <li class="mb-3">
          <strong>To save or protect an individual's vital interest.</strong>
          <span class="text-black d-block mt-1"> We may process your information when necessary to save or protect an
            individual’s vital
            interest, such as to prevent harm. </span>
        </li>
      </ul>
    </div>
    <div id="info3"  class="mb-4">
      <h3 class="fw-semibold fs-4 text-black cursor-pointer">3. WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR INFORMATION?  </h3>
      <p class="text-black "><strong>In Short:</strong>
         We only process your personal information when we believe it is necessary and we have a valid legal reason
        (i.e., legal basis) to do so under applicable law, like with your consent, to comply with laws, to provide you
        with services to enter into or fulfill our contractual obligations,
        to protect your rights, or to fulfill our legitimate business interests. 
    </div>
    <div id="info4"  class="mb-4">
      <h3 class="fw-semibold fs-4 text-black cursor-pointer ">4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?  </h3>
      <p class="text-black "><strong>In Short:</strong>
         We may share information in specific situations described in this section and/or with the following third
        parties.
        <br>We may need to share your personal information in the following situations: <br>
        <strong>Business Transfers.</strong> We may share or transfer your information in connection with, or during
        negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our
        business
        to another company. 
    </div>
    <div  id="info5" class="mb-4">
      <h3 class="fw-semibold fs-4 text-black cursor-pointer">5. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?  </h3>
      <p class="text-black "><strong>In Short:</strong>
        We may use cookies and similar tracking technologies (like web beacons and pixels) to access or store
        information.
      <p class="text-black "> We may use cookies and similar tracking technologies (like web beacons and pixels) to
        access or store information.
        Specific information about how we use such technologies and how you can refuse certain cookies is set out in our
        Cookie Notice.  
    </div>
    <div  id="info6" class="mb-4">
      <h3 class="fw-semibold fs-4 text-black cursor-pointer">6. HOW DO WE HANDLE YOUR SOCIAL LOGINS?  </h3>
      <p class="text-black "><strong>In Short:</strong>
         If you choose to register or log in to our Services using a social media account, we may have access to certain
        information about you. 
      <p class="text-black"> Our Services offer you the ability to register and log in using your third-party social
        media
        account details
        (like your Facebook or Twitter logins). Where you choose to do this, we will receive certain profile information
        about you from your social media provider. The profile information we receive may vary depending on the social
        media provider concerned, but will often include your name, email address, friends list, and profile picture,
        as well as other information you choose to make public on such a social media platform. </p>
      <p class="text-black ">
        We will use the information we receive only for the purposes that are described in this privacy notice or that
        are
        otherwise made clear to you on the relevant Services. Please note that we do not control, and are not
        responsible
        for, other uses of your personal information by your third-party social media provider. We recommend that you
        review their privacy notice to understand how they collect,
        use, and share your personal information, and how you can set your privacy preferences on their sites and apps. 
      </p>
    </div>
    <div  id="info7" class="mb-4">
      <h3 class="fw-semibold fs-4 text-black cursor-pointer">7. HOW LONG DO WE KEEP YOUR INFORMATION?  </h3>
      <p class="text-black "><strong>In Short:</strong>
        We keep your information for as long as necessary to fulfill the purposes outlined in this privacy notice unless
        otherwise required by law. 
      <p class="text-black ">We will only keep your personal information for as long as it is necessary for the purposes
        set out in this
        privacy notice,
        unless a longer retention period is required or permitted by law (such as tax, accounting, or other legal
        requirements). No purpose in this notice will require us keeping your personal information for longer
        than thirty
        six (36) months past the start of the idle period of the user's account. 
         </p>
      <p class="text-black ">
        When we have no ongoing legitimate business need to process your personal information, we will either delete
        or anonymize such information, or, if this is not possible (for example, because your personal information has
        been stored in backup archives),
        then we will securely store your personal information and isolate it from any further processing until deletion
        is
        possible. 
      </p>
    </div>
    <div id="info8"  class="mb-4">
      <h3 class="fw-semibold fs-4 text-black cursor-pointer">8. HOW DO WE KEEP YOUR INFORMATION SAFE? </h3>
      <p class="text-black "><strong>In Short:</strong>
        We aim to protect your personal information through a system of organizational and technical security measures. 
      <p class="text-black ">We have implemented appropriate and reasonable technical and organizational security
        measures
        designed to protect
        the security of any personal information we process. However, despite our safeguards and efforts to secure your
        information-n, no electronic transmission over the Internet or information storage technology can be guaranteed
        to
        be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other unauthorized third
        parties will not be able to defeat our security and improperly collect, access, steal, or modify your
        information.
        Although we will do our best to protect your personal information,
        transmission of personal information to and from our Services is at your own risk. You should only access the
        Services within a secure environment.
         </p>
    </div>
    <div  id="info9" class="mb-4">
      <h3 class="fw-semibold fs-4 text-black cursor-pointer">9. DO WE COLLECT INFORMATION FROM MINORS? </h3>
      <p class="text-black "><strong>In Short:</strong>
         We do not knowingly collect data from or market to children under 18 years of age. 
      <p class="text-black ">We do not knowingly solicit data from or market to children under 18 years of age. By using
        the Services, you
        represent that you are at least 18 or that you are the parent or guardian of such a minor and consent to such
        minor dependent’s use of the Services. If we learn that personal information from users less than 18 years of
        age
        has been collected, we will deactivate the account and take reasonable measures to promptly delete such data
        from
        our records.
        If you become aware of any data we may have collected from children under age 18, please contact us
        at info@cixcent.com.
         </p>
    </div>
    <div id="info10" class="mb-4">
      <h3 class="fw-semibold fs-4 text-black cursor-pointer">10. WHAT ARE YOUR PRIVACY RIGHTS?</h3>
      <p class="text-black">
        <strong>In Short:</strong>
        As a user located in India, you are entitled to certain rights concerning your personal data. These
        rights empower you to access, update, or request deletion of your information, manage your communication
        preferences, and withdraw previously given consent, in accordance with applicable Indian data protection laws.
        <strong>Your Rights Under Indian Law</strong>
      </p>
      <p class="text-black">
        In line with the provisions of the <strong>Digital Personal Data Protection Act, 2023</strong>, and other
        applicable regulations, you have the following rights:
      </p>
      <div class="mb-2">
  <strong>1. Right to Access</strong> – 
  <span class="text-black">You may request access to the personal data we hold about you.</span>
</div>

<div class="mb-2">
  <strong>2. Right to Correction</strong> – 
  <span class="text-black">You may request correction or update of inaccurate or incomplete personal information.</span>
</div>

<div class="mb-2">
  <strong>3. Right to Erasure</strong> – 
  <span class="text-black">You may request deletion of your personal data from our systems, subject to lawful retention obligations.</span>
</div>

<div class="mb-2">
  <strong>4. Right to Withdraw Consent</strong> – 
  <span class="text-black">Where processing is based on your consent, you may withdraw it at any time.</span>
</div>

<div class="mb-2">
  <strong>5. Right to Opt Out of Marketing Communications</strong> – 
  <span class="text-black">You may manage your preferences and opt out of promotional messages.</span>
</div>
      <p class="text-black">
        To exercise these rights, please contact us using the information provided in the section <strong>“HOW CAN YOU CONTACT
        US
        ABOUT THIS NOTICE?”.</strong> We will review and respond to your request in accordance with applicable laws.
      </p>
      <strong>Withdrawing Your Consent</strong>
      <p class="text-black">
        If we rely on your consent for processing your personal data, you have the right to withdraw that consent at any
        time. You may do so by contacting us directly using the contact details provided below.<br>
        Please note that the withdrawal of consent will not affect the lawfulness of data processing carried out before
        the withdrawal, nor will it impact processing activities performed on legal grounds other than consent.
      </p>
      <p class="text-black">
        You may opt out of receiving marketing communications from us at any time by:
      </p>
      <ul>
        <li>
          <p class="text-black">Responding with <strong>"STOP"</strong> or <strong>"UNSUBSCRIBE"</strong> to any SMS
            messages you receive from us, or</p>
        </li>
        <li>
          <p class="text-black">Contacting us using the official communication channels provided below.</p>
        </li>
      </ul>
      <p class="text-black">Please note that even if you opt out of marketing messages, you may still receive essential
        communications related to your account and services. </p>
      <strong>Account Information Management </strong>
      <p class="text-black">
        If you would like to access, modify, or delete the information associated with your Getikk account, you may do
        so
        through the following options: </p>
      <ul>
        <li>
          <p class="text-black"> <strong>Log into your Getikk account</strong> and update your account settings, or</p>
        </li>
        <li>
          <p class="text-black"> <strong>Contact our support team for </strong> assistance</p>
        </li>
      </ul>
      <p class="text-black">Upon receiving a request for account deletion, we will deactivate or remove your account
        data
        from our active systems.
        However, certain data may be retained for fraud prevention, legal compliance, enforcement of agreements, and
        dispute resolution, in accordance with applicable laws. </p>
      <strong>Use of Cookies and Similar Technologies </strong>
      <p class="text-black">Most web browsers are configured to accept cookies by default. You may choose to configure
        your browser settings to remove or reject cookies.
        However, disabling cookies may impact your ability to use certain features or functionalities of our Services. 
      </p>
      <strong>Questions or Concerns? </strong>
      <p class="text-black">If you have any questions, concerns, or requests related to your privacy rights or personal
        data, you may contact us at: </p>
      <p class="text-black">
        Email:
        <a href="mailto:info@cixcent.com" class="text-primary text-decoration-none">info@cixcent.com</a>
      </p>
      <p class="text-black">
        Website:
        <a  routerLink="/home" target="_blank" class="text-primary text-decoration-none">https://getikk.com</a>
      </p>
    </div>
    <div id="info11" class="mb-4">
      <h3 class="fw-semibold fs-4 text-black cursor-pointer">11. CONTROLS FOR DO-NOT-TRACK FEATURES</h3>
      <p class="text-black ">Most web browsers and some mobile operating systems and mobile applications include a
        Do-Not-Track ("DNT") feature or setting you can activate to signal your privacy preference not to have data
        about
        your online browsing activities monitored and collected. At this stage no uniform technology standard
        for recognizing and implementing DNT signals has been finalized. As such, we do not currently respond to DNT
        browser signals or any other mechanism that automatically communicates your choice not to be tracked online.
        If a standard for online tracking is adopted that we must follow in the future, we will inform you about that
        practice in a revised version of this privacy notice.
         </p>
    </div>
    <div id="info12" class="mb-4">
      <h3 class="fw-semibold fs-4 text-black cursor-pointer ">12. DO WE MAKE UPDATES TO THIS NOTICE?</h3>
      <p class="text-black "><strong>In Short:</strong>
         Yes, we will update this notice as necessary to stay compliant with relevant laws
         </p>
      <p class="text-black ">We may update this privacy notice from time to time. The updated version will be indicated
        by
        an updated "Revised" date and the updated version will be effective as soon as it is accessible. If we make
        material changes to this privacy notice, we may notify you either by prominently posting a notice of such
        changes
        or by directly sending you a notification.
        We encourage you to review this privacy notice frequently to be informed of how we are protecting your
        information.</p>
    </div>
    <div id="info13" class="mb-4">
      <h3 class="fw-semibold fs-4 text-black cursor-pointer">13. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</h3>
      <p class="text-black">If you have questions or comments about this notice, you may email us at <span class="text-primary">info@cixcent.com </span>or by post to: </p>
      <p class="text-black ">Cixcent Technologies Private Limited  </p>
      <p class="text-black ">H.No: 109, Hi-Tension Rd , Sri Sai Baba Officer's Colony </p>
      <p class="text-black ">Hyderabad , Telangana 500094 </p>
      <p class="text-black ">India</p>
    </div>
    <div id="info14" class="mb-4">
      <h3 class="fw-semibold fs-4 text-black cursor-pointer " id="info14">14. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?
      </h3>
      <p class="text-black "><strong>In Short:</strong>
        In accordance with applicable Indian data protection laws, you have the right to request access to, correction
        of,
        or deletion of the personal information we collect from you. 
        To review, update, or request deletion of your personal data, you can contact us directly at: 
         </p>
      <p class="text-black">
        Email:
        <a href="mailto:info@cixcent.com" class="text-primary text-decoration-none">info@cixcent.com</a>
      </p>
      <p class="text-black ">We will process your request in a timely manner and in accordance with the relevant legal
        requirements. </p>
    </div>
    <p class="text-black fs-4">Back to Website <a routerLink="/home"
        class="text-primary text-decoration-none">https://getikk.com/</a></p>
        </div>